import { fetchAPIData } from "./data";
import React, { useRef, useEffect, useState } from "react";
import { useStore } from "./state";
import shallow from "zustand/shallow";
import CountUp from "react-countup";
import { MapSVG } from "./components/SVG_Map";
const { innerWidth: _width, innerHeight: _height } = window;
const co2_factor = 0.846;

function numberFormat(num) {
  return Number(num)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

const LocationInfo = ({
  x,
  y,
  siteId,
  mouseOnLoc,
  totals,
  setActive,
  location,
}) => {
  const [overTooltip, setOverTooltip] = useState(false);

  const siteTotals = totals[siteId];

  return (
    <div
      className={`location-tooltip ${
        (mouseOnLoc == true || overTooltip == true) && "show"
      }`}
      style={{
        top: y - 100,
        left: x - 4,
      }}
      onMouseEnter={() => {
        setOverTooltip(true);
      }}
      onMouseLeave={() => {
        setOverTooltip(false);
      }}
      onClick={() => setActive(location)}
    >
      <div className="d-flex justify-content-between">
        <p>Total capacity</p>
        <p className="ms-2">
          <span className="fw-bold">10</span> kwh
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p>This months production</p>
        <p className="ms-2">
          <span className="fw-bold">
            {numberFormat(siteTotals.prod_30 / 1000)}
          </span>{" "}
          kwh
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p>Total production</p>
        <p className="ms-2">
          <span className="fw-bold">
            {numberFormat(siteTotals.prod_total / 1000)}
          </span>{" "}
          kwh
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <p>CO&#178; savings</p>
        <p className="ms-2">
          <span className="fw-bold">
            {numberFormat((siteTotals.prod_total / 1000) * co2_factor)}
          </span>{" "}
          lbs
        </p>
      </div>

      <div className="mt-2 ms-auto cursor-pointer d-flex justify-content-end align-items-end">
        <a
          onClick={() => setActive(location)}
          className="d-flex justify-content-end align-items-end"
        >
          <span className="mt-auto m-0 d-inline-block"> View Data</span>{" "}
          <img
            src="/map_assets/data.svg"
            alt="Open Data"
            style={{
              height: "auto",
              width: 20,
            }}
            className="ps-1 mb-1"
          />
        </a>
      </div>
    </div>
  );
};

export default function StaticMap({ locations, modalShow }) {
  const { active_location, setActiveLocation } = useStore(
    (state) => ({
      active_location: state.active_location,
      setActiveLocation: state.setActiveLocation,
    }),
    shallow
  );

  const [tooltipParams, setTooltipParams] = useState({
    x: 0,
    y: 0,
    site: "",
    mouseOnLoc: false,
    api_key: "",
    location: {},
  });

  const [totals, setTotals] = useState({});
  const [overalls, setOveralls] = useState({
    capacity: 60,
    prod_30: 0,
    prod_total: 0,
    carbon_saved: 0,
  });

  const [currLocation, setCurrLocation] = useState(locations[0]);

  function setActive(location) {
    setActiveLocation(location);
    modalShow();
  }

  useEffect(() => {
    let totals = {};
    let overall_30 = 0;
    let overall_total = 0;
    locations.forEach((el) => {
      let siteId = el.site_id;
      let api_key = el.api_key;

      if (siteId != "") {
        let prod_total = 0;
        fetchAPIData(siteId, api_key).then((data) => {
          data[4].data.energyDetails.meters[0].values.forEach((element) => {
            prod_total += element.value;
          });
          totals[siteId] = {
            capacity: 10,
            prod_30: data[2].data.energyDetails.meters[0].values[0].value,
            prod_total: prod_total,
          };

          overall_30 += data[2].data.energyDetails.meters[0].values[0].value;
          overall_total += prod_total;

          setOveralls((ps) => ({
            ...ps,
            prod_30:
              overalls.prod_30 +
              data[2].data.energyDetails.meters[0].values[0].value,
            prod_total: ps.prod_total + prod_total,
          }));
        });
      } else {
        totals[siteId] = {
          capacity: 0,
          prod_30: 0,
          prod_total: 0,
        };
      }
    });
    console.log("Totals", overall_30, overall_total);
    setTotals(totals);
  }, [locations]);

  if (overalls.prod_30 == 0) {
    return <div></div>;
  }

  return (
    <div className="map-wrapper d-flex flex-column">
      <img
        src="logo.png"
        alt="Dvele"
        style={{
          height: "auto",
          width: 160,
        }}
        className="main-logo ps-2 ps-md-4 pt-4"
      />
      <h1 className="main-title ps-2 ps-md-4 pb-4 text-align-base d-flex align-items-end m-0">
        Virtual Grid
        <img
          src="map_assets/solar.svg"
          alt="Dvele"
          style={{
            height: "auto",
            width: 30,
          }}
          className="ms-2 logo-img"
        />
      </h1>

      <div className="top-bar px-2 px-md-4 py-4">
        <div
          className="row mt-4 overall-stats mx-auto"
          style={{ maxWidth: 900 }}
        >
          <div className="col-md p-0 p-md-1 pt-2 pt-md-0 pt-3 pt-md-0">
            <div className="d-flex flex-row-reverse flex-md-row justify-content-between justify-content-md-center">
              <div className="stat-icon-container">
                <img
                  src="map_assets/Capacity.svg"
                  alt="Dvele"
                  style={{
                    height: "auto",
                    width: 30,
                  }}
                  className="me-4 mb-auto"
                />
              </div>

              <div className="d-flex d-md-block align-items-center">
                <h5 className="fw-bolder me-1">Total Capacity</h5>
                <p>
                  <span className="fw-bold">
                    {" "}
                    <CountUp start={0} end={60} />{" "}
                  </span>
                  kWh
                </p>
              </div>
            </div>
          </div>
          <div className="col-md p-0 p-md-1 pt-2 pt-md-0">
            <div className="d-flex flex-row-reverse flex-md-row justify-content-between justify-content-md-center">
              <div className="stat-icon-container">
                <img
                  src="map_assets/Production.svg"
                  alt="Dvele"
                  style={{
                    height: "auto",
                    width: 30,
                  }}
                  className="me-4 mb-auto"
                />
              </div>
              <div className="d-flex d-md-block align-items-center">
                <h5 className="fw-bolder me-1">Total Production</h5>
                {/*<p>
                  This month
                  <span className="fw-bold">
                    {" "}
                    {numberFormat(overalls.prod_30 / 1000)}{" "}
                  </span>
                  kWh
              </p>*/}
                <p>
                  <span className="fw-bold">
                    {" "}
                    {overalls.prod_total !== 0 && (
                      <CountUp
                        start={0}
                        end={Number(overalls.prod_total / 1000)}
                      />
                    )}{" "}
                  </span>
                  kWh
                </p>
              </div>
            </div>
          </div>
          <div className="col-md p-0 p-md-1 pt-2 pt-md-0">
            {" "}
            <div className="d-flex flex-row-reverse flex-md-row justify-content-between justify-content-md-center">
              <div className="stat-icon-container co2">
                <img
                  src="map_assets/CO2.svg"
                  alt="Dvele"
                  style={{
                    height: "auto",
                    width: 45,
                  }}
                  className="me-3 me-md-4 mb-auto"
                />
              </div>
              <div className="d-flex d-md-block align-items-center">
                <h5 className="fw-bolder me-1">Total CO&#178; Saved</h5>
                <p>
                  <span className="fw-bold">
                    {overalls.prod_total !== 0 && (
                      <CountUp
                        start={0}
                        end={Number((overalls.prod_total / 1000) * co2_factor)}
                      />
                    )}{" "}
                  </span>
                  lbs
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sep-line"></div>
      <div className="map-container flex-grow-1">
        <MapSVG
          setTooltipParams={setTooltipParams}
          locations={locations}
          setActive={setActive}
        />
        {Object.keys(totals).length > 1 && (
          <LocationInfo
            x={tooltipParams.x}
            y={tooltipParams.y}
            siteId={tooltipParams.site}
            mouseOnLoc={tooltipParams.mouseOnLoc}
            totals={totals}
            setActive={setActive}
            location={tooltipParams.location}
          />
        )}
      </div>
    </div>
  );
}
